import React from "react";
import HeroSection from "../components/HeroSection";
import FeatureSection from "../components/FeatureSection";
import CTASection from "../components/CTASection";
import StatSection from "../components/StatSection";
import CourseSection from "../components/CourseSection"
import Footer from "../components/Footer";
import logoImage from "../assets/logo.png"

function Navbar() {
    return (
      <header className="bg-white shadow-md fixed top-0 left-0 w-full z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-xl font-bold text-primary">
            <img src={logoImage} alt="Logo Image" className="w-[100px] h-[80px]"/>
          </h1>
          {/* <nav className="hidden md:flex space-x-6">
            <a href="#fitur" className="text-textmain hover:text-primary font-medium">Fitur</a>
            <a href="#daftar" className="text-textmain hover:text-primary font-medium">Daftar</a>
          </nav> */}
          <div className="space-x-2 hidden md:flex">
            <a href="/login">
              <button className="border border-primary text-primary px-4 py-1 rounded-full hover:bg-primary hover:text-white transition">Masuk</button>
            </a>
            {/* <button className="bg-primary text-white px-4 py-1 rounded-full hover:bg-accent transition">Daftar</button> */}
          </div>
        </div>
      </header>
    );
  }



export default function LandingPage() {
  return (
    <div className="min-h-screen bg-secondary text-textmain font-sans pt-20">
       <Navbar />
      <HeroSection />
      <StatSection/>
      <CourseSection/>
      <FeatureSection />
      <CTASection />
      <Footer />
    </div>
  );
}
